import React from 'react';
import { VictoryPie } from 'victory';
import InfoCardWidget from './infoCardWidget';
import './statisticsWidget.css';

const InfoCardWithPieChartWidget = ({ primaryColor, secondaryColor, title, icon, data, chartData, chartColors, loading, comment }) => {
  return (
    <InfoCardWidget { ...{ primaryColor, secondaryColor, title, icon, data, loading, comment } }>
      {
        chartData && chartData.length > 0 &&
          <div className="chart-container">
            <VictoryPie
              data={chartData} labelRadius={30} colorScale={chartColors} padding={1}
              style={{ data: { stroke: '#ffffff', strokeWidth: 3 }, labels: { fill: '#ffffff', fontSize: 14, fontWeight: 'bold' } }}
            />
          </div>
      }

    </InfoCardWidget>
  );
};

export default InfoCardWithPieChartWidget;



// WEBPACK FOOTER //
// ./src/components/statisticsWidgets/infoCardWithPieChartWidget.js